import React from 'react';
import classnames from 'classnames';

import classes from './DoubleButton.scss';

type Props = {
    background: 'orange' | 'green' | 'white' | 'gray' | 'transparent';
    dimensions: 'small' | 'medium' | 'big' | 'round' | 'textOnly';
    onclick?: () => void;
    secondaryOnClick?: () => void;
    text: string;
    secondaryText?: string;
    icon?: string;
    secondaryIcon?: string;
};

export const DoubleButton: React.FC<Props> = ({
    background,
    dimensions,
    onclick,
    secondaryOnClick,
    icon,
    secondaryIcon,
    text,
    secondaryText,
}) => (
    <div
        className={classnames(classes.doubleButtonContainer, {
            [classes[dimensions]]: dimensions,
            [classes[background]]: background,
        })}
    >
        <button type="button" className={classes.doubleButton} onClick={onclick}>
            {icon && <img className={classes.icon} src={`../../../static/icons/${icon}`} alt="" />}
            <span>{text}</span>
            <span className={classes.doubleButtonRight}></span>
        </button>
        <button
            type="button"
            className={classnames(classes.doubleButton, classes.doubleButtonSecond)}
            onClick={secondaryOnClick}
        >
            {secondaryIcon && <img className={classes.icon} src={`../../../static/icons/${secondaryIcon}`} alt="" />}
            <span>{secondaryText}</span>
        </button>
    </div>
);
